import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async index(projectId: Id, data: ApiRequests['api.v1.contract-events.index']) {
    return await api(route('api.v1.contract-events.index', { project: projectId }), 'get', {
      data,
      casts: {
        status: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        next_action_assignee_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        search: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async show(id: Id) {
    return await api(route('api.v1.contract-events.show', { contract_event: id }), 'get');
  },

  async create(projectId: Id, data: ApiRequests['api.v1.contract-events.store'] | FormData) {
    return await api(route('api.v1.contract-events.store', { project: projectId }), 'post', {
      data,
      casts: {
        date_of_occurrence: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.contract-events.update']) {
    return await api(route('api.v1.contract-events.update', { contract_event: id }), 'patch', {
      data,
    });
  },

  async registerVariationOrder(contractEventId: Id) {
    return await api(
      route('api.v1.contract-events.register-variation-order', contractEventId),
      'post',
    );
  },

  async registerDelay(contractEventId: Id) {
    return await api(route('api.v1.contract-events.register-delay', contractEventId), 'post');
  },

  async registerVariationOrderAndDelay(contractEventId: Id) {
    return await api(
      route('api.v1.contract-events.register-variation-order-and-delay', contractEventId),
      'post',
    );
  },

  async decline(contractEventId: Id) {
    return await api(route('api.v1.contract-events.decline', contractEventId), 'post');
  },

  async media(id: Id) {
    return await api(route('api.v1.contract-events.media.show', id), 'get');
  },

  async storeMedia(id: Id, data: ApiRequests['api.v1.contract-events.media.store'] | FormData) {
    return await api(route('api.v1.contract-events.media.store', id), 'post', {
      data,
    });
  },

  async nextAction(id: Id, data: ApiRequests['api.v1.contract-events.next-action']) {
    return await api(route('api.v1.contract-events.next-action', id), 'patch', {
      data,
      casts: {
        next_action: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        next_action_assignee_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        next_action_due_date: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async saveNextAction(id: Id) {
    return await api(route('api.v1.contract-events.save-next-action', id), 'post');
  },

  async comment(id: Id, data: ApiRequests['api.v1.contract-events.comments']) {
    return await api(route('api.v1.contract-events.comments', id), 'post', {
      data,
    });
  },
};
